import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./CheckoutStatusPage.css";

const CART_STORAGE_KEY = "rungdo_cart_v1";

export default function CheckoutSuccessPage() {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem(CART_STORAGE_KEY);
    window.dispatchEvent(new Event("cart-updated"));
  }, []);

  return (
    <div className="checkout-page">
      <Navbar />
      <main className="checkout-main">
        <section className="checkout-card">
          <div className="checkout-icon success">✓</div>
          <h1>Payment Successful</h1>
          <p>
            Your payment has been received successfully. Thank you for your order.
          </p>
          <div className="checkout-actions">
            <button type="button" className="checkout-primary-btn" onClick={() => navigate("/e-store")}>
              Continue Shopping
            </button>
            <button type="button" className="checkout-secondary-btn" onClick={() => navigate("/")}>
              Go to Home
            </button>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
